//export {};

export const msalConfig = {
    auth: {

        //clientId: process.env.REACT_APP_CLIENT_ID || 'ede8aa3e-9f42-401c-a014-c40ff1d18881',
        clientId: process.env.REACT_APP_CLIENT_ID || '',
        authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
        redirectUri: process.env.REACT_APP_CALLBACK,

    },
    cache: {
        cacheLocation: 'sessionStorage',
    },

};
